import { Country, State } from 'country-state-city';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { CommonAutocomplete } from '../../index';

// Function for selecting country
export const CountrySelector = ({
  selectedCountry,
  setSelectedCountry,
  field,
  errors,
  inputKey,
  disabled,
}: any) => {
  const intl = useIntl();
  const countries = Country.getAllCountries();

  const currentValue = countries.find(
    item => selectedCountry && item.isoCode === selectedCountry.isoCode,
  ) || null;

  return (
    <CommonAutocomplete
      id="country-select"
      keyProp="country"
      value={currentValue}
      placeholder={intl.formatMessage({ id: 'billinginfo.billingcontact.placeholder.country' })}
      options={countries}
      onChange={(_e, item) => {
        field.onChange(item.isoCode);
        setSelectedCountry(item);
      }}
      inputKey={inputKey}
      errors={errors}
      getOptionLabel={option => option.name}
      disabled={disabled}
      required
    />
  );
};

export const StateSelector = ({
  selectedCountry,
  selectedState,
  setSelectedState,
  field,
  errors,
  inputKey,
  disabled,
}: any) => {
  const intl = useIntl();
  const states = State.getStatesOfCountry(selectedCountry?.isoCode);
  const currentValue = states.find(
    item => selectedState && item.isoCode === selectedState.isoCode,
  ) ?? null;

  useEffect(() => {
    if (states.length === 0) {
      // If no states are available, clear the selected state
      field.onChange('');
    }
  }, [states]);

  return (
    <CommonAutocomplete
      id="state-select"
      keyProp="state"
      value={currentValue}
      placeholder={intl.formatMessage({ id: 'billinginfo.billingcontact.placeholder.state' })}
      options={states}
      onChange={(_e, item) => {
        field.onChange(item.name);
        setSelectedState(item);
      }}
      inputKey={inputKey}
      errors={errors}
      getOptionLabel={option => option.name}
      required={states.length > 0}
      disabled={disabled || states.length === 0} // Disable if no states available
    />
  );
};
